import { colors } from "@material-ui/core";

export default {
	root: {
		backgroundColor: colors.grey[50],
		color: colors.grey[900],
	},
	deletable: {
		"&:focus": {
			backgroundColor: colors.grey[100],
		},
	},
};
